import React, { Suspense } from "react";
import styled from "styled-components";
import RoundTextBlack from "../assets/Rounded-Text-Black.png";
import { keyframes } from "styled-components";

// import CoverVideo from '../components/CoverVideo';
// import NavBar from '../components/NavBar';
// import Logo from './../components/Logo';

const Cover = React.lazy(() => import("../components/Cover"));
const Logo = React.lazy(() => import("../components/Logo"));

const Section = styled.section`
	position: relative;
	min-height: 100vh;
	overflow: hidden;
`;

const Home = () => {
	return (
		<Section id="home">
			<Suspense fallback={<></>}>
				<Logo />
				<Cover />
				<RoundText>
					<Circle>&#x2193;</Circle>
					<img src={RoundTextBlack} alt="" />
				</RoundText>
			</Suspense>
		</Section>
	);
};

const rotate = keyframes`
  100%{
    transform: rotate(1turn);
  }
`;

const RoundText = styled.div`
	position: absolute;
	right: 10%;
	top: 2rem;
	width: 6rem;
	height: 6rem;
	border: 1px solid ${(props) => props.theme.text};
	border-radius: 50%;
	img {
		width: 100%;
		height: auto;
		animation: ${rotate} 6s linear infinite reverse;
	}
	@media (max-width: 64em) {
		width: 4rem;
		height: 4rem;
		left: 80%;
		right: 2rem;
		top: 20%;
		bottom: 50%;
	}
	@media (max-width: 48em) {
		right: 1rem;
	}
`;

const Circle = styled.span`
	width: 3rem;
	height: 3rem;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	background-color: ${(props) => props.theme.text};
	color: ${(props) => props.theme.body};
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: ${(props) => props.theme.fontxl};
	@media (max-width: 64em) {
		width: 2rem;
		height: 2rem;
		font-size: ${(props) => props.theme.fontlg};
	}
	@media (max-width: 48em) {
		right: 1rem;
	}
`;


export default Home;